





































import ShippingAddressItem from '@/components/molecules/ShippingAddress/ShippingAddressItem.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import { ShippingAddress } from '@/types/generated/graphql'
import { mapActions, mapState } from 'vuex'
import confirmMixin, { ConfirmOptionType } from '@/mixin/confirmMixin'
import XConfirm from '@/components/atoms/Confirm/XConfirm.vue'
import XCard from '@/components/atoms/Card/XCard.vue'

interface DataType {
  shippingAddresses: ShippingAddress[]
}

export default confirmMixin.extend({
  name: 'ShippingAddressList',
  mixins: [confirmMixin],
  components: {
    ShippingAddressItem,
    XButton,
    XConfirm,
    XCard,
  },
  computed: {
    ...mapState('shippingAddress', ['shippingAddresses']),
    ...mapState('loading', ['loading']),
  },
  async created() {
    await this.fetch()
  },
  methods: {
    ...mapActions('shippingAddress', [
      'fetch',
      'changeMain',
      'deleteAddress',
      'register',
    ]),
    async onChangeMain(id: string) {
      await this.changeMain(id)
      await this.fetch()
    },
    async onDelete(
      this: {
        showConfirm: (option: Partial<ConfirmOptionType>) => void
        deleteAddress: (id: string) => void
        fetch: () => void
      },
      id: string
    ) {
      this.showConfirm({
        okHandler: async () => {
          await this.deleteAddress(id)
          await this.fetch()
        },
      })
    },
    add() {
      this.$emit('add-address-clicked')
    },
    handleClick() {
      this.$router.push({ name: 'Account' })
    },
  },
})
